module.exports = __webpack_public_path__ + "static/media/GotQuestions.e3f4d7c4.png";